import { WSServerMessageSchema, } from '@sit/notifications-shared';
import { WebSocket } from 'partysocket';
export class NotificationClient {
    socket;
    listeners = new Set();
    reconnectListeners = new Set();
    authToken = null;
    constructor(url) {
        let wsUrl = url;
        if (wsUrl.startsWith('http://')) {
            wsUrl = wsUrl.replace('http://', 'ws://');
        }
        else if (wsUrl.startsWith('https://')) {
            wsUrl = wsUrl.replace('https://', 'wss://');
        }
        this.socket = new WebSocket(wsUrl);
        this.socket.addEventListener('message', (event) => this.handleMessage(event));
        this.socket.addEventListener('open', () => this.handleOpen());
        // Add error listener
        this.socket.addEventListener('error', (event) => {
            console.error('NotificationClient: WebSocket error observed', event);
        });
    }
    connect() {
        this.socket.reconnect();
    }
    disconnect() {
        this.socket.close();
    }
    authenticate(token) {
        this.authToken = token;
        if (this.socket.readyState === WebSocket.OPEN) {
            this.sendAuth();
        }
    }
    sendAuth() {
        if (!this.authToken) {
            return;
        }
        const msg = { type: 'auth', token: this.authToken };
        // Validate outgoing just in case?
        // WSClientMessageSchema.parse(msg);
        this.socket.send(JSON.stringify(msg));
    }
    handleOpen() {
        // Re-authenticate on reconnect
        if (this.authToken) {
            this.sendAuth();
        }
        this.notifyReconnect();
    }
    handleMessage(event) {
        try {
            const data = JSON.parse(event.data);
            const result = WSServerMessageSchema.safeParse(data);
            if (!result.success) {
                console.warn('Invalid WebSocket message received:', result.error);
                return;
            }
            const message = result.data;
            switch (message.type) {
                case 'notification':
                    this.notifyListeners(message.data);
                    break;
                case 'authenticated':
                    // Optional: emit authenticated event
                    break;
                case 'error':
                    console.error('WebSocket server error:', message.code, message.message);
                    break;
            }
        }
        catch (error) {
            console.error('Failed to handle WebSocket message', error);
        }
    }
    onNotification(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }
    onReconnect(listener) {
        this.reconnectListeners.add(listener);
        return () => this.reconnectListeners.delete(listener);
    }
    notifyListeners(notification) {
        this.listeners.forEach((l) => {
            l(notification);
        });
    }
    notifyReconnect() {
        this.reconnectListeners.forEach((l) => {
            l();
        });
    }
}
//# sourceMappingURL=notification-client.js.map